import React from 'react';

export const SIDEBAR_SECTIONS = [
    { id: 'modules', label: 'Modules' },
    { id: 'elements', label: 'Elements' },
    { id: 'palette', label: 'Feature Palette' },
    { id: 'layout', label: 'Structure' },
    { id: 'ai-design', label: 'Style Assistant' }
];

/**
 * Accordion header + body for a GuiBuilder sidebar section.
 * Sections fold independently so more than one can be open.
 */
export default function SidebarAccordion({ id, label, open, onToggle, children }) {
    return (
        <div style={{
            border: '1px solid var(--border)',
            borderRadius: '8px',
            background: 'var(--bg-primary)',
            overflow: 'hidden',
            flexShrink: 0
        }}>
            <button
                type="button"
                className={`item-highlight${open ? ' is-selected' : ''}`}
                onClick={() => onToggle(id)}
                aria-expanded={open}
                style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '0.75rem',
                    padding: '0.7rem 0.85rem',
                    borderRadius: 0
                }}
            >
                <span style={{
                    fontWeight: 700,
                    fontSize: '0.8rem'
                }}>
                    {label}
                </span>
                <i
                    className={`fa-solid ${open ? 'fa-chevron-down' : 'fa-chevron-right'}`}
                    style={{ fontSize: '0.7rem', flexShrink: 0 }}
                    aria-hidden="true"
                />
            </button>
            {open && (
                <div style={{
                    borderTop: '1px solid var(--border)',
                    padding: '0.85rem',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.75rem'
                }}>
                    {children}
                </div>
            )}
        </div>
    );
}

SidebarAccordion.displayName = 'GuiBuilder.SidebarAccordion';
